const validate = async(name,value,formData)=>{
    let error = {status:false,message:''}
    let isField = schema[name];
    const fieldNames = {
        Title: 'Job Title',
        Technology:'Technology'
    };
    if(isField){
        let validation = isField;
        for(let i=0;i<validation.length;i++){
            switch(validation[i]){
                case 'required':
                if(value==''){
                    error = {status:true,message:`${fieldNames[name]} is required`};
                    return error;
                }
            }
        }
    }
    return error;
}

const schema = {
    Title:['required'],
    Technology:['required'],
    ActiveDate:['required'],
    // TargetDate:['required']
}
export default validate;
